import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../../sharecomponents/CloseButton';
import VainillaDialog from '../../../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../../../utils/Common';
import Post from '../../../../../../utils/Post';

const EditorValvula = (p) => {
    const ranchos = p.ranchos ?? [];
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const [data, setdata] = useState({
        id: p.data.id ?? null,
        codigo: p.data.codigo ?? "",
        codigo2: p.data.codigo2 ?? "",
        ranchoId: p.data.ranchoId ?? "",
        rancho_nombre: p.data.rancho_nombre ?? "",
        largo: p.data.largo ?? "",
        no_camas: p.data.no_camas ?? "",
        totalm2: p.data.totalm2 ?? "",
        micro: p.data.micro ?? "",
        electrificada: p.data.electrificada ?? "",
        hoops: p.data.hoops ?? "",
        sombra: p.data.sombra ?? "",
        tipo_agua: p.data.tipo_agua ?? "",
    });

    const close = p.close ?? (() => { });
    const keys = [
        { key: 'codigo', name: 'CODIGO', type: "text", tipo: 'input' },
        { key: 'codigo2', name: 'NOMBRE ALTERNATIVO', type: "text", tipo: 'input' },
        { key: 'largo', name: 'LARGO CAMA', type: "number", tipo: 'input' },
        { key: 'no_camas', name: 'NUM. CAMAS', type: "number", tipo: 'input' },
        { key: 'totalm2', name: 'METROS2 TOTALES', type: "number", tipo: 'input' },
        { key: 'micro', name: 'MICROASPERSIÓN', tipo: 'select', options: [{ name: 'SI', value: 'SI' }, { name: 'NO', value: 'NO' }] },
        { key: 'electrificada', name: 'ELECTRIFICADA', tipo: 'select', options: [{ name: 'SI', value: 'SI' }, { name: 'NO', value: 'NO' }] },
        { key: 'hoops', name: 'HOOPS', tipo: 'select', options: [{ name: 'SI', value: 'SI' }, { name: 'NO', value: 'NO' }] },
        { key: 'sombra', name: 'SOMBRA', tipo: 'select', options: [{ name: 'SI', value: 'SI' }, { name: 'NO', value: 'NO' }] },
        { key: 'tipo_agua', name: 'TIPO DE AGUA', tipo: 'select', options: [{ name: 'SIN RO', value: 'SIN RO' }, { name: 'RO', value: 'RO' }] },
    ];
    const containerStyle = "form-group bw-350 mt-2 mb-2";

    const change = (e) => {
        let { name, value } = e.target;
        let ndata = { ...data };
        ndata[name] = value;
        if (['largo', 'no_camas'].includes(name) && ndata.largo !== "" && ndata.no_camas !== "") ndata.totalm2 = +ndata.largo * ndata.no_camas;
        setdata(ndata);
    }

    const eliminarConfimacion = () => {
        setdialog({
            tipo: "error",
            show: true,
            title: "CONFIRME PARA CONTINUAR",
            body: "¿Realmente desea eliminar la valvula?",
            respYes: "Si, eliminar",
            respNot: "Cancelar",
            funct: (resp) => { if (resp) eliminar(); setdialog({ show: false }) },
            size: 'm'
        });
    }

    const eliminar = async () => {
        let resp = await Post('catalogos/valvulas/delete', { id: data.id }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Ocurrió un error');
            return;
        }
        close(true);
    }

    const actualizar = async () => {
        if (data.codigo === "" || data.ranchoId === "" || data.largo === "" || data.no_camas === "" || data.totalm2 === "" || data.micro === "" || data.electrificada === "" || data.hoops === "" || data.sombra === "" || data.tipo_agua === "") {
            activeDialog(setdialog, 'Debes llenar y seleccionar todos los campos', 'error', 'Error');
            return;
        }
        let resp = await Post('catalogos/valvulas/add', data, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Ocurrió un error');
            return;
        }
        close(true);
    }


    return (
        <div className='vw-100 vh-100 fixed blur-xl bw-white4 overflow' style={{ zIndex: 10, top: 0, left: 0 }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-300 mt-2 bg-white3 border shadow round-xxl text-center text-300 h4'>{data.id ? "EDICIÓN DE VALVULA" : "CREACIÓN DE VALVULA"}</div>
                <div className='w-100 m-0 p-0'></div>
                <div className='bw-800 p-2 round-m bg-white shadow-multi m-0'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 mt-4 text-center text-bold mb-0 p-0 text-l'>{data.id ? "EDICIÓN DE VALVULA" : "CREACIÓN DE VALVULA"}</div>
                        <div className='bw-400 border-bottom border-warning m-0 p-0'></div>
                        <div className='w-100'></div>
                        {keys.map((k, i) =>
                            <div className='form-group bw-350 mt-3 p-0' key={'input' + i}>
                                <label className='text-bold'>{k.name}</label>
                                {k.tipo === 'input' && <input type={k.type} name={k.key} value={data[k.key]} className='form-control border shadow' autoComplete='off' onChange={change} />}
                                {k.tipo === 'select' &&
                                    <select className='form-control border shadow' name={k.key} value={data[k.key]} onChange={change}>
                                        {(data.id === null) && <option value=''>SELECCIONE UNA OPCIÓN</option>}
                                        {k.options.map((o, j) => <option key={j + k.name} value={o.value}>{o.name}</option>)}
                                    </select>
                                }
                            </div>
                        )}
                        <div className='form-group bw-350 mt-3 p-0' >
                            <label className='text-bold'>RANCHO</label>
                            <select className='form-control border shadow' name='ranchoId' value={data.ranchoId} onChange={change}>
                                {(data.id === null) && <option value=''>SELECCIONE UNA OPCIÓN</option>}
                                {ranchos.map((r, j) => <option key={j + r.nombre} value={r.id}>{r.nombre}</option>)}
                            </select>
                        </div>

                        <div className='w-100 mt-4'></div>
                        {data.id && <div className='bw-200 m-0 p-0'>
                            <button className='btn btn-danger shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={eliminarConfimacion}
                            >Eliminar valvula</button>
                        </div>}
                        <div className='w-100'></div>
                        <div className='bw-400 mt-4 mb-3 ms-0 me-0'>
                            <button className='btn btn-warning shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={actualizar}
                            >{data.id ? 'Guardar cambios' : "Agregar"}</button>
                        </div>
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader && <div className='vw-100 vh-100 blur-l bg-white4' style={{ position: "fixed", top: 0, left: 0 }}>
                <div className='loader'></div>
            </div>}
        </div>
    )
}

export default EditorValvula;